import React, { ReactNode } from "react";
import PromiseLoadingSpinner from "features/shared/components/loaders/PromiseLoadingSpinner";
import DeviceTypeEnum from "features/shared/enums/DeviceTypeEnum";
import Content from "features/shared/layout/content/Content";
import TopBarLogo from "features/shared/layout/topbar/components/TopBarLogo";
import TopBarSimple from "features/shared/layout/topbar/components/TopBarSimple";
import ContentDialog from "features/shared/components/contentDialog/ContentDialog";
import styles from "./layout.module.scss";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import { UserState } from "redux-oidc";
import RenderWrapper from "../components/renderWrapper/RenderWrapper";

interface Props {
  children: ReactNode;
  useSpinner?: boolean;
  fixedWidht?: boolean;
}

const SimpleLayout = ({
  children,
  useSpinner = false,
  fixedWidht = false,
}: Props) => {
  // store
  const user = useSelector<IAppState, UserState>((store) => store.oidc).user;

  // render
  return (
    <>
      <RenderWrapper isVisible={() => user !== null}>
        <TopBarLogo type={DeviceTypeEnum.MOBILE} />
      </RenderWrapper>
      <TopBarSimple />
      <div
        className={`${styles.pageContainer}${
          fixedWidht ? " " + styles.fixedWidth : ""
        }`}
      >
        <Content>
          {children}
          {useSpinner && <PromiseLoadingSpinner delay={100} />}
        </Content>
      </div>
      <ContentDialog />
    </>
  );
};

export default SimpleLayout;
